"use strict";

require("core-js/modules/es6.object.is");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _shallowEquals = _interopRequireDefault(require("unmutable/shallowEquals"));

var _Errors = require("../errors/Errors");

var _ChangeRequestReducer = _interopRequireDefault(require("../change/ChangeRequestReducer"));

var _get = _interopRequireDefault(require("../parcelData/get"));

var ChangeRequest =
/*#__PURE__*/
function () {
  function ChangeRequest() {
    var _this = this;

    var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    (0, _classCallCheck2["default"])(this, ChangeRequest);
    (0, _defineProperty2["default"])(this, "_actions", []);
    (0, _defineProperty2["default"])(this, "_prevData", void 0);
    (0, _defineProperty2["default"])(this, "_nextData", void 0);
    (0, _defineProperty2["default"])(this, "_originId", null);
    (0, _defineProperty2["default"])(this, "_originPath", null);
    (0, _defineProperty2["default"])(this, "_revertCallback", void 0);
    (0, _defineProperty2["default"])(this, "_nextFrameMeta", {});
    (0, _defineProperty2["default"])(this, "_create", function (_ref) {
      var actions = _ref.actions,
          nextFrameMeta = _ref.nextFrameMeta,
          prevData = _ref.prevData; // never copy nextData as the cache may be invalid

      var changeRequest = new ChangeRequest();
      changeRequest._actions = actions || _this._actions;
      changeRequest._originId = _this._originId;
      changeRequest._originPath = _this._originPath;
      changeRequest._revertCallback = _this._revertCallback;
      changeRequest._nextFrameMeta = nextFrameMeta || _this._nextFrameMeta;
      changeRequest._prevData = prevData; // or else this is undefined

      return changeRequest;
    });
    (0, _defineProperty2["default"])(this, "_addStep", function (step) {
      return _this._create({
        actions: _this._actions.map(function (ii) {
          return ii._addStep(step);
        })
      });
    });
    (0, _defineProperty2["default"])(this, "_revert", function () {
      _this._revertCallback && _this._revertCallback(_this);
    });
    (0, _defineProperty2["default"])(this, "merge", function (other) {
      var actions = other._actions.reduce(function (actions, thisAction) {
        var lastAction = actions.slice(-1)[0];
        var shouldReplace = lastAction && thisAction.type === "set" && lastAction.type === "set" && thisAction.keyPath.join(".") === lastAction.keyPath.join(".");

        if (shouldReplace) {
          actions = actions.slice(0, -1);
        }

        return actions.concat(thisAction);
      }, _this._actions);

      var nextFrameMeta = (0, _objectSpread2["default"])({}, _this._nextFrameMeta, other._nextFrameMeta);
      return _this._create({
        actions: actions,
        nextFrameMeta: nextFrameMeta
      });
    });
    (0, _defineProperty2["default"])(this, "getDataIn", function (keyPath) {
      var getIn = function getIn(data) {
        return keyPath.reduce(function (data, key) {
          return (0, _get["default"])(key)(data);
        }, data);
      };

      return {
        next: getIn(_this.nextData),
        prev: getIn(_this.prevData)
      };
    });
    (0, _defineProperty2["default"])(this, "hasDataChanged", function () {
      var keyPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var _this$getDataIn = _this.getDataIn(keyPath),
          next = _this$getDataIn.next,
          prev = _this$getDataIn.prev;

      return !Object.is(next.value, prev.value) || !(0, _shallowEquals["default"])(next.meta || {})(prev.meta || {});
    });
    (0, _defineProperty2["default"])(this, "hasValueChanged", function () {
      var keyPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var _this$getDataIn2 = _this.getDataIn(keyPath),
          next = _this$getDataIn2.next,
          prev = _this$getDataIn2.prev;

      return !Object.is(next.value, prev.value);
    });
    this._actions = this._actions.concat(action);
  }

  (0, _createClass2["default"])(ChangeRequest, [{
    key: "nextData",
    // $FlowFixMe - this doesn't have side effects
    get: function get() {
      var _nextData = this._nextData;

      if (_nextData) {
        return _nextData;
      }

      this._nextData = (0, _ChangeRequestReducer["default"])(this)(this.prevData);
      return this._nextData;
    } // $FlowFixMe - this doesn't have side effects
    ,
    set: function set(value) {
      throw (0, _Errors.ReadOnlyError)();
    } // $FlowFixMe - this doesn't have side effects

  }, {
    key: "prevData",
    get: function get() {
      if (!this._prevData) {
        throw (0, _Errors.ChangeRequestNoPrevDataError)();
      }

      return this._prevData;
    } // $FlowFixMe - this doesn't have side effects
    ,
    set: function set(value) {
      throw (0, _Errors.ReadOnlyError)();
    } // $FlowFixMe - this doesn't have side effects

  }, {
    key: "actions",
    get: function get() {
      return this._actions;
    } // $FlowFixMe - this doesn't have side effects
    ,
    set: function set(value) {
      throw (0, _Errors.ReadOnlyError)();
    }
  }, {
    key: "originId",
    // $FlowFixMe - this doesn't have side effects
    get: function get() {
      return this._originId;
    } // $FlowFixMe - this doesn't have side effects
    ,
    set: function set(value) {
      throw (0, _Errors.ReadOnlyError)();
    } // $FlowFixMe - this doesn't have side effects

  }, {
    key: "originPath",
    get: function get() {
      return this._originPath;
    } // $FlowFixMe - this doesn't have side effects
    ,
    set: function set(value) {
      throw (0, _Errors.ReadOnlyError)();
    }
  }]);
  return ChangeRequest;
}();

exports["default"] = ChangeRequest;